import { fetcher } from '@commenda/utils';
import { BulkUploadProps, BulkUploadResponse } from './types';

export async function bulkUploadProducts(
  body: BulkUploadProps,
  token: string
): Promise<{
  success: boolean;
  data?: BulkUploadResponse;
  error?: string;
}> {
  try {
    // Strip signedUrl from file object - backend doesn't accept it
    const { signedUrl: _, ...fileWithoutSignedUrl } = body.file;
    const sanitizedBody = {
      ...body,
      file: fileWithoutSignedUrl,
    };

    const response = await fetcher(
      `new-sales-tax/products/bulk/csv`,
      { method: 'POST', body: sanitizedBody },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error uploading products:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to upload products',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to upload products';
    console.error('Failed to upload products:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}
